/**
 * Shell-only wiring: injects the app axios client into the PoL module (modules/POL/FE).
 * No PoL business logic lives here — see modules/POL/FE/src/services/polService.ts.
 */
import apiService from './api';
import { configurePolApiClient } from '@signals/pol-ui/polApi';
import { polService, PolService } from '@signals/pol-ui/services/polService';

configurePolApiClient(apiService.client);

export { polService, PolService };
export default polService;
export type {
  DashboardResponse,
  EntitySummary,
  RecurringPattern,
  DigitalInsightsResponse,
  EntityCorrelation,
  PolAnomaly,
  LocationSequence,
  RoutePattern,
  DigitalPattern,
  DigitalSimilarity,
  SimilarEntity,
  AnomalySummary,
  CoursesResponse,
  CourseInfo,
} from '@signals/pol-ui/services/polService';
